module.exports = __webpack_public_path__ + "img/T and C Icon - white.9861d110.svg";